import { lazy } from "react";

const Order = lazy(() => import("./features/Order"));
const InputNum = lazy(() => import("./features/InputNum"));
const Home = lazy(() => import("./features/Home"));
const ProductList = lazy(() => import("./features/ProductList"));
export const AppRoutes = (props) => [
  {
    path: "/order",
    component: Order,
    props: props
  },
  {
    path: "/input-num",
    component: InputNum,
    props: props
  },
  {
    path: "/",
    component: Home,
    props: props
  },
  {
    path: "/product",
    component: ProductList,
    props: props
  },
];
